export const degree = {
  pep: {
    aba: {
      sourceKey: "src_2gYLSWBYFW3A6KCwhFes9fiYIk3",
      writeKey: "wk_2gYLScmsQVPEKMAUqYEkIiYKvfe",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
    },
    mls: {
      sourceKey: "src_2gYLOKwTBIXPDUwkx59PzbmKoho",
      writeKey: "wk_2gYLOLqNJKeBY3Ep1Rs11xp8gJ6",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
    },
    map: {
      sourceKey: "src_2gYLGzcICLBDvJKLBUvhTYWStON",
      writeKey: "wk_2gYLH1n5TM8pxO2eB4E1zjiEzmZ",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
    },
    mft: {
      sourceKey: "src_2gYLBbb6qsvM4NN0uElqK1MtqJp",
      writeKey: "wk_2gYLBaNWueG3FoqNWZIzBzeKSR6",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
    },
    lpc: {
      sourceKey: "src_2gYLBbb6qsvM4NN0uElqK1MtqJp",
      writeKey: "wk_2gYLBaNWueG3FoqNWZIzBzeKSR6",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
    },
    "lpc-lmft": {
      sourceKey: "src_2mDM5G8rTu8c9pPBFA8Ydo2TOIU",
      writeKey: "wk_2mDM5Gs7sVovWm1JFnvUKnG2YtT",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
    },
    "map-aba-lpc-lmft": {
      sourceKey: "src_2mDMApmmQqehjpkWmDPwQtSWegJ",
      writeKey: "wk_2mDMAs4DVGNsMlV3a85IP71tYPM",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
    },
    "map-aba": {
      sourceKey: "src_2mDMEqA72uKDPHODSgVrwfEoD8R",
      writeKey: "wk_2mDMEuX8v91pwcNasObVrnGIkCO",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
    },
    "map-aba-lpc": {
      sourceKey: "src_2gYLSWBYFW3A6KCwhFes9fiYIk3",
      writeKey: "wk_2gYLScmsQVPEKMAUqYEkIiYKvfe",
      oneTrust: "01922054-e602-780c-afe6-6ed1507d86b1",
      segmentId: "EyFGCCphV5zMfiyCYml1NfHhrjFS8Gd0",
    },
  },
  rice: {
    mba: {
      sourceKey: "src_2gYLMfThBpMbzO5oMNfHQO0ZjJ7",
      writeKey: "wk_2gYLMgKCoBRat7VEhmIalLnfEry",
      oneTrust: "01922056-cfc3-71b9-b973-4f04bc0708ec",
      segmentId: "v2Fx166KGDNfrRxA5nSqAKD3OwMnopIH",
    },
  },
  ec: {
    speech: {
      sourceKey: "src_2gYLA9qkJxRXllou3xGKDzXe2vO",
      writeKey: "wk_2gYLA3j0MWpxMoWijjwpJhlvFOo",
      oneTrust: "0192206b-2816-7c50-a6eb-144a5c88fb50",
      segmentId: "dyIXNShkjOIClOlavHZreKCRuTZF4LrF",
    },
  },
  ucd: {
    mba: {
      sourceKey: "src_2gYL3e7SfWFGqIDjE52EVoSH76A",
      writeKey: "wk_2gYL3eAd8xH87Gb4VKP3PFEbVsX",
      oneTrust: "0192205a-c0ba-7c38-bdae-209777f165d0",
      segmentId: "y0JN4KYb2IIlUicknJ8Oead2tHvNm5ss",
    },
  },
  nu: {
    counseling: {
      sourceKey: "src_2gYL2b5ESovHWWENVcAy1ayBpcu",
      writeKey: "wk_2gYL2YiakwWDbzOLKb9H3VIxz43",
      oneTrust: "01922065-d173-7d5f-b21c-6112d66d85ab",
      segmentId: "dB3KICL8cqT4Nrv9v47NQNH66RNSNhw8",
    },
    "counseling-mac": {
      sourceKey: "src_2gYL2b5ESovHWWENVcAy1ayBpcu",
      writeKey: "wk_2gYL2YiakwWDbzOLKb9H3VIxz43",
      oneTrust: "01922065-d173-7d5f-b21c-6112d66d85ab",
      segmentId: "dB3KICL8cqT4Nrv9v47NQNH66RNSNhw8",
    },
    mft: {
      sourceKey: "src_2gYKjIDpNyvMZaYxKRZNvkCf17P",
      writeKey: "wk_2gYKjHKYBXdpcKSVbIBqBjPfqDd",
      oneTrust: "01922067-a858-73f4-a38e-4af020142dfb",
      segmentId: "YgR3GXOpjDfyxGVa5bNvwrZJXIXdndpW",
    },
  },
  den: {
    sw: {
      sourceKey: "src_2gYKwQeddVXjtKIXPzdRaiZ6FED",
      writeKey: "wk_2gYKwNCIIThV0hGcjAioxzYxdcZ",
      oneTrust: "01922062-df1b-7445-94b8-60298d5f23ce",
      segmentId: "GBXoFrJjUjir6ScgvYioqwA3Tm4JGfPy",
    },
  },
  gu: {
    nursing: {
      sourceKey: "src_2gYKmz8s4wQLe6FrFipl6HKXolI",
      writeKey: "wk_2gYKmySVp1zcsmAv6tr9x5JvCR5",
      oneTrust: "01922064-490e-7ed3-ace2-61d80404c38f",
      segmentId: "zCyNokEa26Wi2DPmSRqgOHApXAfbIMLH",
    },
    "nursing-agacnp": {
      sourceKey: "src_2gYKmz8s4wQLe6FrFipl6HKXolI",
      writeKey: "wk_2gYKmySVp1zcsmAv6tr9x5JvCR5",
      oneTrust: "01922064-490e-7ed3-ace2-61d80404c38f",
      segmentId: "zCyNokEa26Wi2DPmSRqgOHApXAfbIMLH",
    },
    "nursing-fnp": {
      sourceKey: "src_2gYKmz8s4wQLe6FrFipl6HKXolI",
      writeKey: "wk_2gYKmySVp1zcsmAv6tr9x5JvCR5",
      oneTrust: "01922064-490e-7ed3-ace2-61d80404c38f",
      segmentId: "zCyNokEa26Wi2DPmSRqgOHApXAfbIMLH",
    },
    "nursing-nmwhnp": {
      sourceKey: "src_2gYKmz8s4wQLe6FrFipl6HKXolI",
      writeKey: "wk_2gYKmySVp1zcsmAv6tr9x5JvCR5",
      oneTrust: "01922064-490e-7ed3-ace2-61d80404c38f",
      segmentId: "zCyNokEa26Wi2DPmSRqgOHApXAfbIMLH",
    },
  },
  ucb: {
    cybersecurity: {
      sourceKey: "src_2gYKEOPTua7yjjnnMd1QyVuPBRQ",
      writeKey: "wk_2gYKENaH43YLVtfqYg7doPvdFhT",
      oneTrust: "0191dd29-174a-78e8-89ec-c72709a78792",
      segmentId: "7xZuMqu2aQcoyod3wd4CfiYmqd3Viyoy",
    },
    data: {
      sourceKey: "src_2f0e4osgNx4oYpZnrntTDGH1Av8",
      writeKey: "wk_2f0e4o0VpT8Z4aMY6tYWU3FJSyV",
      oneTrust: "0191dd29-174a-78e8-89ec-c72709a78792",
      segmentId: "7xZuMqu2aQcoyod3wd4CfiYmqd3Viyoy",
    },
  },
  unc: {
    mba: {
      sourceKey: "src_2gYKdqXid5r4cyKhdnV3KJKp7l4",
      writeKey: "wk_2gYKdoVztYDYAhnAOZ2zpnKrbvb",
      oneTrust: "0192205e-268e-7f5c-9ab3-34769dbf3432",
      segmentId: "fZXOadTbThH2w4bd3SaV8fbIY2wFYDOJ",
    },
  },
  gwu: {
    "pub-health": {
      sourceKey: "src_2hQ14oFhMomTqkfF8hZupyq3Rn5",
      writeKey: "wk_2hQ14phJTVp3uGWPaZiZzN6u2nr",
    },
  },
  mia: {
    mba: {
      sourceKey: "src_2hQ1BGC1S5F49gi2Iqq5a45CAJd",
      writeKey: "wk_2hQ1BDKG58JzacjVe8UPOihrRph",
      oneTrust: "0192206e-a20a-70b7-9e83-afb7e2c15f9a",
      segmentId: "GkTIBa22bQcKIXPHaQalRI9ntEbWBUWZ",
    },
  },
  mvu: {
    mba: {
      sourceKey: "src_2mGMeSUnO5q7HNxdfqywrOKuir3",
      writeKey: "wk_2mGMeWcguhW8qliyGd6sBwQP7lX",
      oneTrust: "019248bd-8604-7b21-8246-5038c98fdfa8",
      segmentId: "SSIynLBPX4loEcZL8bdPVhMspl2x5UKX",
    },
  },
  nyu: {
    speech: {
      sourceKey: "src_2hQ1Qp6IhyVt3coCoEFChE0Bjl5",
      writeKey: "wk_2hQ1QoY2agXYWt1wPdv6qip92cO",
    },
    counseling: {
      sourceKey: "src_2hQ1VhOZhvpw4x78dC3IZNgdVOW",
      writeKey: "wk_2hQ1VjrBbqYzVf2Iu3ZyeTUYdmk",
    },
  },
  syr: {
    "libr-info": {
      sourceKey: "src_2hQ1ZW5q20BncaAnCkK4vDHqDiD",
      writeKey: "wk_2hQ1ZWQ4LvttKfDdjdC7buq5QLT",
    },
    sw: {
      sourceKey: "src_2mLLcZdS1B9h3uQtoxNc5OcaED9",
      writeKey: "wk_2mLLcYfYwMrdqe9BtpKfRCEnuoW",
    },
  },
};
